exports = module.exports = require("../../../../_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cube-drawer-item{padding:0 .533333rem;height:1.333333rem;line-height:1.333333rem;white-space:nowrap;overflow:hidden;font-size:.4rem}.cube-drawer-item:after{left:.533333rem}.cube-drawer-item:last-child:after{display:none}.cube-drawer-item:first-child:after{display:block}.cube-drawer-item_active{background:rgba(0,0,0,.04)}", ""]);

// exports
